import * as React from 'react';
import {Link} from "react-router-dom";
import {FalconNavigatorHeader, productHelper, ProductsEnum, Quote} from "@falcon/services";
import FalconHeader from "../../../../components/navigation/FalconHeader";
import FalconFooter from "../../../../components/navigation/FalconFooter";
import {NewQuotePageBase} from "./NewQuotePageBase";
import Header from "../../../../components/navigation/Header";

interface IState {
    annualMotorQuotes: Quote[];
    annualHomeQuotes: Quote[];
    isCustomer: boolean;
}

export class ViewOrGetQuotesPage extends NewQuotePageBase<{}, IState> {
    private readonly ANNUAL_QUOTES_PAGE: string = "/dashboard/annualQuotes";
    private readonly HOME_INSURANCE_QUOTES_PAGE: string = "/dashboard/HomeInsuranceQuotes";

    constructor(props: Readonly<{}>) {
        super(props);
        this.state = {
            annualMotorQuotes: [],
            annualHomeQuotes: [],
            isCustomer: false
        }
    }

    public render() {
        const annualMotorEnabled: boolean = process.env.REACT_APP_ANNUAL_MOTOR_ENABLED ? JSON.parse(process.env.REACT_APP_ANNUAL_MOTOR_ENABLED) : true;
        const annualHomeEnabled: boolean = process.env.REACT_APP_ANNUAL_HOME_ENABLED ? JSON.parse(process.env.REACT_APP_ANNUAL_HOME_ENABLED) : false;
            return (
                <React.Fragment>
                    {this.state.isCustomer ?
                        <FalconHeader/>
                        :
                        <Header/>
                    }
                            <div className="plugin view-or-get-quotes-page">
                                <FalconNavigatorHeader back="/dashboard" title={this.state.isCustomer ? "Get a new quote or view saved quotes" : "Get a new quote"}/>
                                <div className="get-quote-allianz mx-3">
                                    {annualMotorEnabled && this.renderAnnualMotorTile()}
                                    {annualHomeEnabled && this.renderAnnualHomeTile()}
                                </div>
                                {this.renderRenewalDateCapturePanel()}
                                {this.pluginTemplates.renderBackLink("Back", false, "/dashboard")}
                            </div>
                    <FalconFooter/>
                </React.Fragment>
            )
    }

    private renderAnnualMotorTile = () => {
        const annualMotorQuoteCount: number = this.state.annualMotorQuotes.length;
        const hasMotorQuotes: boolean = annualMotorQuoteCount > 0;
        const linkToNbJourney = this.getMotorNBPageLink();
        return (
            <div className="section-panel-get-quote">
                {this.renderMotorQuoteTile(annualMotorQuoteCount)}
                <Link
                    to={hasMotorQuotes ? this.ANNUAL_QUOTES_PAGE : linkToNbJourney}
                    className="inner-content buttonLink"
                    id="viewSavedSubscriptionCarQuotes">
                    <button type="button" className="btn btn-primary btn-add">
                        {hasMotorQuotes ? "View your car quote(s)" : "Car quote"}
                    </button>
                </Link>
                <div className="quote-panel-view-quotes">
                    {
                        hasMotorQuotes
                            ? <Link
                                to={linkToNbJourney}>
                                Get a new car quote
                            </Link>
                            : <p className="mb-0">
                                You don't have any car quotes
                            </p>
                    }
                </div>
        </div>)
    }

    private renderAnnualHomeTile = () => {
        const annualHomeQuoteCount: number = this.state.annualHomeQuotes.length;
        const hasHomeQuotes: boolean = annualHomeQuoteCount > 0;
        const linkToNbJourney = `${productHelper.getNewBusinessUrl(ProductsEnum.HOME)}/dashboardEntryPage`;

        return (
            <div className="section-panel-get-quote">
                {this.renderHomeQuoteTile(annualHomeQuoteCount)}
                <Link
                    to={hasHomeQuotes ? this.HOME_INSURANCE_QUOTES_PAGE : linkToNbJourney}
                    className="inner-content buttonLink"
                    id="viewSavedSubscriptionHomeQuotes">
                    <button type="button" className="btn btn-primary btn-add">
                        {hasHomeQuotes ? "View your home quote" : "Home quote"}
                    </button>
                </Link>

                {this.renderGetNewQuoteLink(annualHomeQuoteCount, linkToNbJourney)}
            </div>
        )
    }

    private getMotorNBPageLink() {
        const fromDashboard: boolean = window.sessionStorage.getItem("fromDashboard") === "true";
        return fromDashboard ?
            productHelper.getNewBusinessFromDashboardUrl(ProductsEnum.WOLF_MOTOR) :
            productHelper.getNewBusinessUrl(ProductsEnum.WOLF_MOTOR);
    }
}
